<template>
  <div>
    <div v-show="!onChild">
      <table-title>转户列表</table-title>
      <!-- 查询 -->
      <div class="serach">
        <Form ref="formValidate" :label-width="90" inline>
          <div>
            <FormItem label="转出方">
              <!-- <payee-select class="shrug" roleType="LEASEE" v-model="queryParams.deliverOutLeaseeId"></payee-select> -->
              <bizSelect v-model="queryParams.deliverOutLeaseeId" url="http://MID-OPERATE-LEASE/messageService/deliverService/queryDeliverOutLeaseeList" style="width:185px" />
            </FormItem>
            <FormItem label="接收方">
              <payee-select class="shrug" roleType="LEASEE" v-model="queryParams.deliverInLeaseeId"></payee-select>
            </FormItem>
            <FormItem label="状态">
              <dictSelect v-model="queryParams.status" namespace="ENUM_MID-OPERATE-LEASE" id="deliver.DeliverStatus" :exclusion="[]"></dictSelect>
            </FormItem>
            <FormItem label="标的物小类">
              <target-type-select v-model="queryParams.targetType" />
            </FormItem>
            <FormItem label="操作时间">
              <DatePicker type="daterange" placement="bottom-end" placeholder="请选择时间范围" @on-change="onDateChang" style="width: 200px" transfer></DatePicker>
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="getQuery">查询</Button>
          </div>
        </Form>
      </div>
      <!-- 列表 -->
      <!-- <div class="table">
        <dataGrid ref="dg1" :columns="cols" :queryParams="queryParams" paramsName="params" :pageNum="1" :pageSize="20" :queryUrl="queryUrl" exportId="queryDeliverListByParam4Receive" exportFileName="接收记录">
          <template #default="{columns, data}">
            <Table :columns="columns" :data="data" border stripe size="small" highlight-row>
              <template slot-scope="{ row }" slot="action">
                <Button v-if="row.status=='TO_BE_CONFIRMED'" size="small" type="primary" @click="doTask(row)">办理</Button>
                <Button v-if="row.status=='FINISH'&&row.remainAmount>0" size="small" type="success" @click="toRecycle(row)">归还</Button>
              </template>
            </Table>
          </template>
        </dataGrid>
      </div> -->
      <plt-table ref="tableRef" :url="queryUrl" :queryParams="queryParams" paramName="params" :pageSize="20" exportId="queryDeliverListByParam4Receive" exportFileName="接收记录">
        <el-table-column prop="id" label="转户ID"></el-table-column>
        <el-table-column prop="deliverOutDate" label="转出时间"></el-table-column>
        <plt-table-dict-col label="转出方" prop="deliverOutLeaseeId" namespace="bizObjects" id="member"></plt-table-dict-col>
        <plt-table-dict-col label="接收方" prop="deliverInLeaseeId" namespace="bizObjects" id="member"></plt-table-dict-col>
        <plt-table-dict-col prop="targetType" label="标的物小类" namespace="target" id="type"></plt-table-dict-col>
        <el-table-column label="转户数量" prop="amount"></el-table-column>
        <el-table-column label="接收时间" prop="deliverInDate"></el-table-column>
        <el-table-column label="转户协议" prop="deliverAgreementCode"></el-table-column>
        <plt-table-dict-col prop="deliverAreaId" label="交接地址" namespace="region" id="fullArea" />
        <el-table-column prop="deliverAddress" label="交接详细地址"></el-table-column>
        <el-table-column prop="remark" label="转出备注"></el-table-column>
        <el-table-column prop="confirmRemark" label="接收备注"></el-table-column>
        <plt-table-dict-col prop="status" label="状态" namespace="ENUM_MID-OPERATE-LEASE" id="deliver.DeliverStatus" />
        <el-table-column label="创建时间" prop="createTime">
          <template #default="{ row }">
            <span>
              {{row.createTime?new Date(row.createTime).formatDate():'-'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button v-if="row.status=='TO_BE_CONFIRMED'" size="small" type="primary" @click="doTask(row)">办理</el-button>
            <el-button v-if="row.status=='FINISH'&&row.remainAmount>0" size="small" type="success" @click="toRecycle(row)">归还</el-button>
          </template>
        </el-table-column>
      </plt-table>
    </div>

    <div v-if="onChild">
      <component v-bind:is="currentChild" :deliverInfo="currentRow" @on-finish="onFinish"></component>
    </div>

  </div>
</template>
<script>
import tableTitle from "@/components/tableTitle/tableTitle.vue";

import dataGrid from "@/components/datagrid.vue";
import dictSelect from "@/components/select/dict-select.vue";
import payeeSelect from "@/components/select/payee-select.vue";
import targetTypeSelect from "@/components/select/targetTypeSelect.vue";
import deliverOrderConfirm from "./deliver-order-confirm.vue";
import bizSelect from "@/components/select/biz-select.vue";
export default {
  name: "deliverOrderListIn",
  components: {
    tableTitle,
    dataGrid,
    dictSelect,
    payeeSelect,
    targetTypeSelect,
    deliverOrderConfirm,
    bizSelect,
  },
  data() {
    return {
      queryUrl: "http://MID-OPERATE-LEASE/messageService/deliverService/queryDeliverListByParam4Receive",
      cols: [
        { title: "转户ID", key: "id" },
        { title: "转出时间", key: "deliverOutDate" },
        {
          title: "转出方",
          key: "deliverOutLeaseeId",
          dict: ["bizObjects", "member", true],
        },
        {
          title: "接收方",
          key: "deliverInLeaseeId",
          dict: ["bizObjects", "member", true],
        },
        {
          title: "标的物小类",
          key: "targetType",
          dict: ["target", "type", true],
        },
        { title: "转户数量", key: "amount" },
        { title: "接收时间", key: "deliverInDate" },
        { title: "转户协议", key: "deliverAgreementCode" },
        {
          title: "交接地址",
          key: "deliverAreaId",
          dict: ["region", "fullArea", true],
        },
        { title: "交接详细地址", key: "deliverAddress" },
        { title: "转出备注", key: "remark" },
        { title: "接收备注", key: "confirmRemark" },
        {
          title: "状态",
          key: "status",
          dict: ["ENUM_MID-OPERATE-LEASE", "deliver.DeliverStatus"],
        },
        { title: "创建时间", key: "createTime", formatter: "date" },
        { title: "操作", slot: "action", fixed: "right" },
      ],
      queryParams: {
        deliverOutLeaseeId: "",
        deliverInLeaseeId: "",
        targetType: "",
        status: "",
        startDate: "",
        endDate: "",
      },
      currentChild: "",
      currentRow: {},
      onChild: false,
      memberId: sessionStorage.getItem("memberId"),
    };
  },
  mounted() {},
  methods: {
    onDateChang(val) {
      this.queryParams.startDate = val[0];
      this.queryParams.endDate = val[1];
    },
    getQuery() {
      this.$refs["tableRef"].loadFirstPage();
    },
    doTask(row) {
      this.currentChild = deliverOrderConfirm;
      this.currentRow = row;
      this.onChild = true;
    },
    toRecycle(row) {
      let query = {
        deliverId: row.id,
        contractId: row.contractId,
        remainAmount: row.remainAmount,
        targetType: row.targetType,
        memberId: row.deliverInLeaseeId,
        deliverAreaId: row.deliverAreaId,
        // deliverAddress : row.deliverAddress
      };
      this.$router.push({ path: "/user-center/lease/newReturn", query: query });
    },
    onFinish() {
      this.onChild = false;
      this.$refs["tableRef"].queryData();
    },
  },
};
</script>